module.exports = __webpack_public_path__ + "static/media/nitro.a27a6a38.ttf";